import React, { Component } from "react";
import { Button, FormGroup, Label, Input } from "reactstrap";
import Constants from "../constants";
import { dataObject } from "../constants";

class LayersWidget extends Component {
  getYearLabels = () => {
    const labels = dataObject.map(item => {
      return item.label;
    });
    return labels;
  };

  getSeaLevelOptions = () => {
    const { getYearLevel } = this.props;
    const seaLevelOptions = dataObject[getYearLevel()] && dataObject[getYearLevel()].seaLevels ? dataObject[getYearLevel()].seaLevels  : false;
    return seaLevelOptions;
  };

  getStormLevelOptions = () => {
    const { getYearLevel, getSeaLevel } = this.props;
    const stormLevelOptions =
      dataObject[getYearLevel()] &&
      dataObject[getYearLevel()].seaLevels &&
      dataObject[getYearLevel()].seaLevels[getSeaLevel()].stormEvents
        ? dataObject[getYearLevel()].seaLevels[getSeaLevel()].stormEvents
        : false;

    return stormLevelOptions;
  };

  renderSeaLevelContent = () => {
    const { setSeaLevel, getSeaLevel } = this.props;

    return (
      <div className="sea-level">
        <p>{Constants.slrTitle}</p>
        {this.getSeaLevelOptions().map((seaLevel, seaLevelIndex) => {
          return (
            <div
              className="radio-buttons"
              key={`${seaLevel.label}  ${seaLevelIndex}`}
              onChange={() => {
                setSeaLevel(seaLevelIndex);
              }}
            >
              <FormGroup>
                <Label check>
                  <Input
                    type="radio"
                    name={seaLevel.label}
                    value={seaLevelIndex}
                    checked={getSeaLevel() === seaLevelIndex}
                    readOnly
                  />{" "}
                  {seaLevel.label}
                </Label>
              </FormGroup>
            </div>
          );
        })}
      </div>
    );
  };

  renderStormLevelContent = () => {
    const { setStormLevel, getStormLevel } = this.props;
    const options = {};

    return (
      <div className="storm-surge">
        <p>{Constants.stormSurgeTitle}</p>
        {this.getStormLevelOptions().map((stormLevel, stormLevelIndex) => {
          return (
            <div
              className="radio-buttons"
              key={`${stormLevel.label}  ${stormLevelIndex}`}
              onChange={() => {
                setStormLevel(stormLevelIndex);
              }}
            >
              <FormGroup>
                <Label check>
                  <Input
                    type="radio"
                    name={stormLevel.label}
                    value={stormLevelIndex}
                    checked={getStormLevel() === stormLevelIndex}
                    readOnly
                  />{" "}
                  {stormLevel.label}
                </Label>
              </FormGroup>
            </div>
          );
        })}
      </div>
    );
  };

  renderVunerabilityContent = () => {
    return (
      <div className="vulnerability-level">

        <p>{Constants.vulnerabilityText}</p>

      </div>
    );
  }

  render() {
    const { getYearLevel, setYearLevel } = this.props;

    return (
      <div className="widget-styling">
        <div className="btn-wrapper">
          {this.getYearLabels().map((year, yearIndex) => {
            return (
              <Button
                key={`${year}  ${yearIndex}`}
                id="first"
                className={getYearLevel() === yearIndex ? "btn current" : "btn"}
                outline
                color="primary"
                onClick={e => {
                  setYearLevel(yearIndex);
                }}
              >
                {year}
              </Button>
            );
          })}
        </div>

        <div className="options-selector">
          {this.getSeaLevelOptions() ? this.renderSeaLevelContent() : this.renderVunerabilityContent()}
          {this.getStormLevelOptions() ? this.renderStormLevelContent() : null}
        </div>

          {this.getSeaLevelOptions() ?
    (    <div>
        <hr />
        <p className="footnote">{Constants.footnote}</p>
        </div>) : null }
      </div>
    );
  }
}

export default LayersWidget;
